<template>
  <div class="card">
    <div class="card-body" style="min-height: 22rem">
      <div class="clearfix">
        <div class="float-end">
          <div class="flex-nowrap input-group input-group-sm mb-3">
            <label class="input-group-text bg-light">Date</label>
            <date-picker v-model="paymentsTodayDateSelected" :disabled-dates='futureDisabledDates' class="dashboard-datepicker" fixed-position="top-right" @input="paymentsTodayDateSelectedFn"></date-picker>
          </div>
        </div>
        <h4 class="card-title mb-4">Payments Collected</h4>
      </div>
      <hr class="mb-4" />
      <div>
        <data-table :columns="paymentTodayColumns" :rows="paymentsCollectedReport.objects" :has-pagination="false" :has-search="false"/>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/components/data-table";
import {PAYMENTS_COLLECTED_ON_A_DAY} from "@/gql";
import moment from "moment";
export default {
  name: "PaymentsCollected",
  components: {DataTable},
  data(){
    return {
      paymentsTodayDateSelected: new Date(),
      futureDisabledDates: {
        from: new Date(),
      },
      paymentTodayColumns: [
        {
          field: 'dashboardCustomer',
          label: 'Customer'
        },
        {
          field: 'dashboardOrder',
          label: 'Order'
        },
        {
          field: 'dashboardOrderDate',
          label: 'Order Date'
        },
        {
          field: 'dashboardDeliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'dashboardOrderTotal',
          label: 'Total'
        },
        {
          field: 'dashboardPaymentDetails',
          label: 'Mode of payment',
        },
        {
          field: 'dashboardOrderStatus',
          label: 'Order Status'
        }
      ],
      paymentsCollectedReport: {
        objects: []
      },
      paymentDates: [],
      perPage: 30,
      currentPage: 1
    }
  },
  apollo: {
    paymentsCollectedReport: {
      query: PAYMENTS_COLLECTED_ON_A_DAY,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          paymentDates: this.paymentDates
        }
      }
    },
  },
  methods: {
    paymentsTodayDateSelectedFn(){
      this.paymentDates = [moment(this.paymentsTodayDateSelected).format('YYYY-MM-DD')]
    },
  }
}
</script>

<style scoped>

</style>
